import React from 'react';
import ListLayout from '@presentation/layouts/ListLayout';
import Category from '@presentation/pages/Category';
import { makeCollectionService } from '@main/factories/makeCollectionService';
import type { CollectionModel } from '@domain/models/CollectionModel';

const makeCategory = (category: CollectionModel, firstPage: any, intro?: string) => {
	const collectionsService = makeCollectionService();

	return (
		<ListLayout>
			<Category category={category} firstPage={firstPage} collectionsService={collectionsService} intro={intro} />
		</ListLayout>
	);
};

export default makeCategory;
